import { authMiddleware } from './authMiddleware'
import { anonUserMiddleware } from './injectAnonUser'
import { languageMiddleware } from './languageMiddleware'

export const requestMiddleware = [authMiddleware, anonUserMiddleware, languageMiddleware]
